// ============================================================================
// ENUM MASTER ENDPOINTS
// ============================================================================

import { buildEndpointWithParams } from './base.endpoints';

const BASE_PATH = '/lmms/v1/masters/enums';

export const enumEndpoints = {
  getByGroup: (group: string) => buildEndpointWithParams(`${BASE_PATH}/:group`, { group }),
} as const;

export default enumEndpoints;
